import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/global.css';

// Entry point of the React application. It mounts the root component
// into the DOM and wraps it with a BrowserRouter so that client‑side
// routing is available. The global styles are imported here to apply
// base styles and CSS variables.

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);